var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubjectFav = function SvgIconSubjectFav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-sujets-fav",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "m170.681 103.35-4-2-4 2v-6h8Z",
    transform: "translate(-159.681 -85.35)",
    fill: "#f54c3c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "m170.226 91.968-1.637 1.287.685 2.147a.536.536 0 0 1-.51.7.541.541 0 0 1-.328-.111l-1.756-1.356-1.767 1.356a.536.536 0 0 1-.838-.587l.687-2.148-1.628-1.288a.535.535 0 0 1 .332-.955h2.024l.677-2.044a.537.537 0 0 1 .507-.367.535.535 0 0 1 .508.365l.686 2.046h2.032a.536.536 0 0 1 .331.957Z",
    transform: "translate(-159.681 -85.35)",
    fill: "#ff8500"
  }))));
};
export { SvgIconSubjectFav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdWpldHMtZmF2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cmVjdCBpZD0iYXJlYSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjZjJmMmYyIiBvcGFjaXR5PSIwIi8+CiAgPGcgaWQ9Imljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMTIiIGRhdGEtbmFtZT0iUGF0aCAxMiIgZD0iTTE3MC42ODEsMTAzLjM1bC00LTItNCwydi02aDhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTU5LjY4MSAtODUuMzUpIiBmaWxsPSIjZjU0YzNjIi8+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzIiIGRhdGEtbmFtZT0iRWxsaXBzZSAyIiBjeD0iNyIgY3k9IjciIHI9IjciIGZpbGw9IiNmZmNlMDAiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEzIiBkYXRhLW5hbWU9IlBhdGggMTMiIGQ9Ik0xNzAuMjI2LDkxLjk2OGwtMS42MzcsMS4yODcuNjg1LDIuMTQ3YS41MzYuNTM2LDAsMCwxLS41MS43LjU0MS41NDEsMCwwLDEtLjMyOC0uMTExbC0xLjc1Ni0xLjM1Ni0xLjc2NywxLjM1NmEuNTM2LjUzNiwwLDAsMS0uODM4LS41ODdsLjY4Ny0yLjE0OC0xLjYyOC0xLjI4OGEuNTM1LjUzNSwwLDAsMSwuMzMyLS45NTVoMi4wMjRsLjY3Ny0yLjA0NGEuNTM3LjUzNywwLDAsMSwuNTA3LS4zNjdoMGEuNTM1LjUzNSwwLDAsMSwuNTA4LjM2NWwuNjg2LDIuMDQ2SDE2OS45YS41MzYuNTM2LDAsMCwxLC4zMzEuOTU3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1OS42ODEgLTg1LjM1KSIgZmlsbD0iI2ZmODUwMCIvPgogIDwvZz4KPC9zdmc+Cg==";